  <!--Loading Spinner-->
  <div *ngIf="isLoading">
    <app-spinner></app-spinner>
  </div>

  <!-- Content Header (Page header) -->
  <section class="content-header">
      <div class="content-header">
          <div class="container-fluid">
            <div class="row mb-2">

              <div class="col-sm-6">

              </div><!-- /.col -->

              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item"><a routerLink="/"><i class="nav-icon fas fa-tachometer-alt"></i>&nbsp;Dashboard</a></li>
                  <li class="breadcrumb-item active">Unpaid IDF Charges</li>
                </ol>
              </div><!-- /.col -->
            </div><!-- /.row -->
          </div><!-- /.container-fluid -->
      </div>

      <div class="row">
        <div class="col-md-8">
            <div class="row">

            </div>
        </div>
        <div class="col-md-4">
          <div class="row">
              <div class="col">
                  <input type="text" class="form-control" placeholder="Search by Chassis Number or BL Number" (input)="onSearchTextChange($event)">
              </div>
          </div>
        </div>
      </div>
      </section>
        <!-- /.content-header -->
      <section class="content">
        <div class="container-fluid">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title">Unpaid IDF Charges</h3>
              <!--Error Message-->
              <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
                {{errorMessage}}
              </div>
              <!--Success Message-->
              <div class="alert alert-success" role="alert" *ngIf="successMessage">
                {{successMessage}}
              </div>
            </div>
            <!-- /.card-header -->
            <div class="card-body">
              <table id="example1" class="table table-bordered table-hover">
                <thead>
                  <tr>
                      <th>BL No.</th>
                      <th>Make</th>
                      <th>Model</th>
                      <th>Chassis No.</th>
                      <th></th>
                  </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let vehicle of unpaidIdfCharges | searchEditablePayments: searchText| paginate: { itemsPerPage: 10, currentPage: page, totalItems: count }">
                      <td>{{vehicle.bl_no}}</td>
                      <td>{{vehicle.make}}</td>
                      <td>{{vehicle.model}}</td>
                      <td>{{vehicle.chassis_no}}</td>
                      <td><a (click)="openModal(vehicle.vehicle_id,vehicle.chassis_no,vehicle.make,vehicle.model,vehicle.bl_no)" class="btn btn-success btn-sm" role="button" aria-pressed="true"><i
                        class="fa fa-plus-circle" aria-hidden="true">&nbsp;</i>Add Payment</a></td>
                    </tr>
                </tbody>
              </table>
              <pagination-controls (pageChange)="pageChangeEvent($event)"></pagination-controls>
            </div>
            <!-- /.card-body -->
          </div>
        </div>
      </section>

<!-- Modal -->
<div class="modal fade" #AddPaymentModal tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Add IDF Payment</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <p style="font-weight:bold; margin-left:15px">{{make}} {{model}} ({{chassis_no}})</p>
      <form [formGroup]="form" (ngSubmit)="submit()">
        <div class="modal-body">
            <div class="form-group">
                <label>Amount:<span style="color:red;">*</span></label>
                <div class="input-group mb-3">
                    <div class="custom-file">
                      <input type="text" formControlName="amount" class="form-control" placeholder="Amount">
                    </div>
                </div>

                <span *ngIf="submitted && form.get('amount')?.hasError('required')" style="color:red"> <strong>Please enter amount to proceed!</strong></span>
            </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          <button class="btn btn-success" type="button" *ngIf="isInProgress; else showUpdateBtn" disabled>
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Processing...
          </button>

          <ng-template #showUpdateBtn>
              <button type="submit" class="btn btn-success"><i class="fa fa-save" aria-hidden="true">&nbsp;</i>Submit</button>
          </ng-template>
        </div>
      </form>
    </div>
  </div>
</div>
